export const blueColor = "#061F4F";
export const redColor = "#E30B29";
export const whiteColor = "#061F4F";

export const formStyle = { 
    width : 360,
    borderTopLeftRadius: 10,
    borderTop: `6px solid ${blueColor}`,
    borderTopRightRadius: 10,
    borderBottomRightRadius: 5,
    borderBottomLeftRadius: 5,
};

export const regFormStyle = { 
    ...formStyle,
    width : 700,
};

export const structure = {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  };

export const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };